import LpOptionsIndex from './options';
import LpVariablesIndex from './variables';
import LpConditionDependenciesIndex from './conditions_dependencies';
import LpConditionsIndex from './conditions';
import LpRealSections from './real_sections';
import LpGrandpa from './fatherhood';
import LpGrandpaVariables from './fatherhood_variables';
import LpMultiples from './multiples';
import LpVarToView from './views_by_variables';
import LpRenderContent from './render';
import LpRootOptions from './root_options';
import LpBySectionIndex from './by_section';
// import lpViewHeightIndex from "./view_heights";

/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/indexes.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/
/**
 * This class contains all the index data,
 * * variables
 * * options
 * * dependencies (condition)
 * * conditions
 * * view by variables
 * * multiple index
 * * multiple keys index
 * * outputs
 * * real sections
 */
class LpIndexContainer {
  constructor() {
    this.options = new LpOptionsIndex();
    this.variables = new LpVariablesIndex();
    this.dependencies = new LpConditionDependenciesIndex();
    this.conditions = new LpConditionsIndex();
    this.real_sections = new LpRealSections();
    this.grandpa = new LpGrandpa();
    this.grandpa_vars = new LpGrandpaVariables();
    this.multiples = new LpMultiples();
    this.var_to_view = new LpVarToView();
    this.content = new LpRenderContent();
    this.roots = new LpRootOptions();
    this.sections_cache = new LpBySectionIndex();
    // this.heights = new lpViewHeightIndex();
  }

  /**
     * Centralizing building
     */
  updateOption(opt, i = 0) {
    this.options.updateOption(opt, i);
  }

  updateVariable(var_, i = 0) {
    this.variables.updateVariable(var_, i);
  }

  updateDependencies() {
    this.dependencies.buildDependencies();
  }

  updateConditions() {
    this.conditions.updateConditions();
  }

  updateRealSections(var_) {
    this.real_sections.updateRealSections(var_);
  }

  updateGrandpa(tree) {
    this.grandpa.buildGrandpa(tree);
  }

  updateV2V(obj) {
    this.var_to_view.buildVarToView(obj);
  }

  updateRoots(sections) {
    this.roots.buildRootOptions(sections);
  }
}

export default LpIndexContainer;



// WEBPACK FOOTER //
// ./src/app/indexes/indexes.js